import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { CheckAhRoutingModule } from './check-ah-routing.module';
import { CheckAhComponent } from './check-ah.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { UpdateFileRenComponent } from './update-file-ren.component';
import { RejectRenComponent } from './reject.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    CheckAhComponent,
    UpdateFileRenComponent,
    RejectRenComponent
  ],
  imports: [
    CheckAhRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    Ng2SmartTableModule,
    NgbModule,
    NgxDropzoneModule,
    NgCircleProgressModule.forRoot({}),
  ],
  providers: [NgbActiveModal],
  bootstrap: [
  ],
  entryComponents: [
  ]
})
export class CheckAhModule { }
